/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const DATE_REGEX = /\d{2}\/\d{2}\/\d{4}/;
export const PHONENUMBER_REGEX = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
export const FAXNUMBER_REGEX =
  /^(\+?\d{ 1, }(\s ?|\-?) \d * (\s ?|\-?) \(?\d{ 2,} \)?(\s ?|\-?) \d{ 3,} \s ?\d{ 3,})$/;
